
import { Component, Vue } from 'vue-property-decorator'
import { NavBar, CurationCard } from '@/components'
import FetchWrapper from '@/classes/fetchWrapper'

@Component({
  components: {
    NavBar,
    CurationCard
  }
})
export default class CurationView extends Vue {
  data () {
    return {
      isLoading: false,
      curations: []
    }
  }

  mounted () {
    this.geCurations()
  }

  get isLoggedIn () {
    return this.$store.state.loggedIn
  }

  async geCurations () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getLearningVectorHistsToBeCurated`))
      resp.map(e => {
        var temp = e.category.replaceAll('_', ' ').toLowerCase()
        e.category = temp.charAt(0).toUpperCase() + temp.slice(1)
        e.subject = e.subject.charAt(0).toUpperCase() + e.subject.slice(1)
        return 0
      })
      this.curations = resp
      this.isLoading = false
    } catch (e) {
      this.curations = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get curations.',
        canCancel: false
      })
    }
  }

  async approve (id) {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/approveLearningVectorHist/${id}`))
      if (resp.error) {
        throw resp.error
      }
      var idx = this.curations.findIndex((e) => e.id === id)
      if (idx !== -1) {
        this.curations.splice(idx, 1)
      }
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not approve. Reason: ${e}`,
        canCancel: false
      })
    }
  }

  async reprove (id) {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/disapproveLearningVectorHist/${id}`))
      if (resp.error) {
        throw resp.error
      }
      var idx = this.curations.findIndex((e) => e.id === id)
      if (idx !== -1) {
        this.curations.splice(idx, 1)
      }
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not reprove. Reason: ${e}`,
        canCancel: false
      })
    }
  }
}
